import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Linkedin, Instagram } from "lucide-react";

const SOCIAL = [
  { icon: Twitter, label: "Twitter" },
  { icon: Linkedin, label: "LinkedIn" },
  { icon: Instagram, label: "Instagram" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 md:px-8 h-12 sm:h-16 flex items-center justify-between gap-2 sm:gap-3">
        <Link to="/" data-testid="footer-logo" className="inline-flex items-center shrink-0">
          <img src="/logo.png" alt="Freelancity" className="h-5 sm:h-7 w-auto" width="180" height="28" />
        </Link>

        {/* Desktop: full copyright + tagline */}
        <p
          data-testid="footer-copyright"
          className="hidden sm:block text-xs text-slate-500 text-center truncate"
        >
          © {year} Freelancity · Built for the afterlife of job economy.
        </p>

        {/* Mobile: compact © only, sits between logo and socials */}
        <p
          data-testid="footer-tagline-mobile"
          className="sm:hidden flex-1 min-w-0 text-[10px] leading-tight text-slate-500 text-center whitespace-nowrap px-1"
        >
          © {year} Freelancity
        </p>

        <div className="flex items-center gap-0 sm:gap-1 shrink-0" data-testid="footer-social" aria-hidden="true">
          {SOCIAL.map(({ icon: Icon, label }) => (
            <span
              key={label}
              data-testid={`footer-social-${label.toLowerCase()}`}
              className="grid place-items-center w-6 h-6 sm:w-8 sm:h-8 rounded-md text-slate-400 select-none"
              title={label}
            >
              <Icon size={11} className="sm:w-[15px] sm:h-[15px]" />
            </span>
          ))}
        </div>
      </div>
    </footer>
  );
}
